import { createSlice } from "@reduxjs/toolkit";

const contentExercisesSlice = createSlice({
  name: "contentExercises",
  initialState: {
    availableTopics: [],
    contentFilesExercises: [],
    suggestedTopicsByTeachers: [],
    contentFilesExercisesSelected: {},
  },
  reducers: {
    setAvailableTopics(state, { payload }) {
      state.availableTopics = payload;
    },
    setSuggestedTopicsByTeachers(state, { payload }) {
      state.suggestedTopicsByTeachers = payload;
    },
    setContentFilesExercises(state, { payload }) {
      state.contentFilesExercises = payload;
    },
    setContentFilesExercisesSelected(state, { payload }) {
      state.contentFilesExercisesSelected = payload;
    },
    clearContentExercises(state) {
      state.availableTopics = [];
      state.contentFilesExercises = [];
      state.suggestedTopicsByTeachers = [];
      state.contentFilesExercisesSelected = {};
    },
  },
});

export const {
  setAvailableTopics,
  clearContentExercises,
  setContentFilesExercises,
  setSuggestedTopicsByTeachers,
  setContentFilesExercisesSelected,
} = contentExercisesSlice.actions;

export default contentExercisesSlice.reducer;
